import { createApp } from "vue";
import { createPinia } from "pinia";
import { ElDialog, ElLoading, ElProgress } from "element-plus";
import "element-plus/dist/index.css";
import "./styles.css";
import App from "./App.vue";

const app = createApp(App);
app.use(createPinia());
app.component("ElDialog", ElDialog);
app.component("ElProgress", ElProgress);
app.directive("loading", ElLoading.directive);
app.mount("#app");
